import { render } from "./Faculity-Members.vue?vue&type=template&id=04bf4e3e"
import script from "./Faculity-Members.vue?vue&type=script&lang=js"
export * from "./Faculity-Members.vue?vue&type=script&lang=js"
script.render = render

export default script